"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLabel = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _index = require("../index"); // Copyright © VNG Realisatie 2020
// Licensed under the EUPL
//


var StyledLabel = /*#__PURE__*/(0, _styledComponents["default"])(_index.Label).withConfig({
  displayName: "indexstyles__StyledLabel",
  componentId: "sc-1r99j6o-0"
})(["color:", ";display:inline-flex;align-items:center;line-height:1rem;margin-right:", ";cursor:", ";margin-top:", ";input{margin-right:", ";}"], function (p) {
  return p.theme.colorText;
}, function (p) {
  return p.theme.tokens.spacing08;
}, function (p) {
  return p.disabled ? 'auto' : 'pointer';
}, function (p) {
  return p.theme.tokens.spacing03;
}, function (p) {
  return p.theme.tokens.spacing04;
});
exports.StyledLabel = StyledLabel;